module.exports = __webpack_public_path__ + "img/arrow-down.a2ad73ca.svg";